import { render } from "./accordion-item.vue?vue&type=template&id=0dd7f942"
import script from "./accordion-item.vue?vue&type=script&lang=js"
export * from "./accordion-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__